import React, { Component } from 'react';
import $ from 'jquery';
import PropTypes from 'prop-types';
import Swipe from 'react-easy-swipe';

import { fetchAwards } from '../../helpers/DataProvider';

import PrizeIcon from '../../images/publications/blue-prize.png';
import AwardCell from './awardCell/AwardCell';

import './AwardsSection.css';

class AwardsSection extends Component {
  constructor(props) {
    super(props);

    const { isMobile } = props;

    this.state = {
      maxAwardsPerPage: isMobile ? 1 : 2,
      awards: [],
      currentPageIndex: 0,
      timeToChangePage: isMobile ? 5000 : 10000,
    };

    this.timeout = null;
    this.timeoutID = null;
  }

  componentDidMount() {
    const { maxAwardsPerPage, timeToChangePage } = this.state;

    this.timeout = () => setTimeout(() => this.scrollToNextElement(), timeToChangePage);

    fetchAwards((awards) => {
      this.setState({
        numberPages: Math.ceil(awards.length / maxAwardsPerPage),
        awards: awards.sort((a, b) => b.year - a.year),
      }, () => {
        this.timeoutID = this.timeout();
      });
    });
  }

  scrollToPreviousElement() {
    const { currentPageIndex, numberPages } = this.state;

    if (currentPageIndex === 0) return;

    const previousPage = Math.abs((currentPageIndex - 1) % numberPages);
    this.scrollToElement(previousPage);
  }

  scrollToNextElement() {
    const { currentPageIndex, numberPages } = this.state;

    const nextPage = (currentPageIndex + 1) % numberPages;
    this.scrollToElement(nextPage);
  }

  scrollToElement(pageIndex) {
    const { maxAwardsPerPage } = this.state;

    clearTimeout(this.timeoutID);

    this.setState({
      currentPageIndex: pageIndex,
    }, () => {
      const cellOffset = document.getElementById(`award-${pageIndex}`).offsetLeft;
      const parenOffset = document.getElementsByClassName('AwardList')[0].offsetLeft;
      const leftPos = Math.abs(cellOffset - parenOffset) * maxAwardsPerPage;
      $('div.AwardList').animate({ scrollLeft: leftPos }, 800);
      this.timeoutID = this.timeout();
    });
  }

  render() {
    const {
      awards,
      currentPageIndex,
      numberPages,
      maxAwardsPerPage,
    } = this.state;

    const paddingCells = [...Array(awards.length % maxAwardsPerPage).keys()].map(index => (
      <AwardCell key={`empty-${index}`} emptyCell />
    ));
    return (
      <div className="AwardsSection">
        <div id="AwardsSectionTop">
          <img src={PrizeIcon} alt="Blue Trophy" />
          <Swipe
            onSwipeLeft={() => this.scrollToNextElement()}
            onSwipeRight={() => this.scrollToPreviousElement()}
            className="AwardList"
          >
            {
              awards.length > 0 && awards.map((award, index) => (
                <AwardCell scrollID={`award-${index}`} key={`${award.title}-${award.year}-${award.event}`} award={award} />
              ))
            }
            {
              paddingCells
            }
          </Swipe>
        </div>

        <div id="AwardsSectionBottom">
          <div className="AwardsSteppers">
            {
              numberPages > 0 && [...Array(numberPages).keys()].map((_, index) => (
                <div
                  key={index} /* eslint-disable-line react/no-array-index-key */
                  className={index === currentPageIndex ? 'currentPage' : 'otherPage'}
                  onClick={() => this.scrollToElement(index)}
                  onKeyPress={() => this.scrollToElement(index)}
                  role="radio"
                  tabIndex={0}
                  aria-checked={index === currentPageIndex}
                />
              ))
            }
          </div>
        </div>
      </div>
    );
  }
}

AwardsSection.propTypes = {
  isMobile: PropTypes.bool.isRequired,
};

export default AwardsSection;
